/**
 * SAFE LOCAL STORAGE ACCESS
 * =========================
 *
 * localStorage is not always reachable. Reading `window.localStorage` throws
 * outright when the browser is configured to block site data, `setItem` throws
 * once the origin's quota is full, and the object is absent in non-browser
 * environments. An uncaught failure in a component that reads storage during
 * an effect unmounts the whole app, so every access is guarded here: a storage
 * failure degrades to "no stored value" instead.
 */

function getStore(): Storage | null {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage ?? null;
  } catch {
    return null;
  }
}

export function readStoredValue(key: string): string | null {
  try {
    return getStore()?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStoredValue(key: string, value: string): void {
  try {
    getStore()?.setItem(key, value);
  } catch {
    // A failed write costs the user a remembered preference, nothing more.
  }
}
